import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
type RevealProps = {
  children: React.ReactNode;
  delay?: number;
  className?: string;
};
export function Reveal({
  children,
  delay = 0,
  className
}: RevealProps) {
  const reduce = useReducedMotion();
  return <motion.div className={className} initial={reduce ? false : {
    opacity: 0,
    y: 18
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.3,
    delay,
    ease: [0.23, 1, 0.32, 1]
  }} data-id="element-122" data-mp="3ggphg41x1e8x">
      {children}
    </motion.div>;
}